import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'environments/environment';
import { IUser } from '@core/models/auth/user';
import { AuthLocalService } from '@core/auth/auth-local.service';
import { IArticulo } from '@features/materiales/articulos/models/articulo';

@Injectable()
export class StockPanolService {
  private user: IUser;
  static tituloPanolSel: string;
  private newToken: any;

  constructor(private http: HttpClient, private _authLocal: AuthLocalService) {
    this.user = this._authLocal.getCurrentUser();
  }
  getStocksPorPanol(filtro: any): Observable<any> {
    var subject = new Subject<any>();
    this.http.get<any>((environment.api.materiales.stock_panol.view_stock_panols + (filtro ? filtro : '')), { observe: 'response' })
      .subscribe((resp: any) => {
        this.newToken = resp.body.token;
        this._authLocal.updateToken(this.newToken)
        subject.next({
          'list': resp.body.result,
          'totalPages': resp.headers.get('x-pagination-page-count'),
          'totalCount': resp.headers.get('x-pagination-total-count')
        })
      });
    return subject.asObservable();
  }
  getStockPanols(filtro?: any): Observable<any[]> {
    const subject = new Subject<any[]>();
    this.http.get<any[]>(environment.api.materiales.stock_panol.stock_panols + (filtro ? filtro : '')).subscribe(
      (resp: any) => {
        this.newToken = resp.token; // Guardamos el token recibido
        this._authLocal.updateToken(this.newToken); // Actualizamos el token
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      }
    );
    return subject.asObservable();
  }
  getArticulo(id: any): Observable<IArticulo> {
    const subject = new Subject<IArticulo>();
    this.http.get<any>(environment.api.materiales.articulos.articulos + `/${id}`).subscribe(
      (resp: any) => {
        this.newToken = resp.token; // Guardamos el token recibido
        this._authLocal.updateToken(this.newToken); // Actualizamos el token
        subject.next(resp.result); // Emitimos el objeto directamente
        subject.complete(); // Cerramos el Subject
      }
    );
    return subject.asObservable();
  }
}